(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["specs-and-console"] && !Shopify.designMode) return;
  try {
    
      $(document).ready(function(){
      $( "#spec_open" ).click(function() {
        $("#specs-and-console").slideToggle("slow");
//        $("#specs-and-console svg").toggleClass("fa-plus-circle");
       $('#spec_open svg').attr('data-icon', $('#spec_open svg').attr('data-icon') == 'minus-circle' ? 'plus-circle' : 'minus-circle');
      
      }); 

 
        
    });

  } catch(e) { console.error(e); }
})();
})();
